module.exports = __webpack_public_path__ + "static/img/shiLi-3.919f2bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shiLi-3.png
// module id = aCZ4
// module chunks = 1